import React from "react";

import { SettingsConfirmModal } from "../../../../components/modal/SettingsConfirmModal";
import { TrashSvg } from "../../../../components/svg/TrashSvg";
import { WarningExclaimSvg } from "../../../../components/svg/WarningExclaimSvg";
import { WorkTypesConfirmModalsProps } from "../model/workTypesList.types";

export const WorkTypesConfirmModals: React.FC<WorkTypesConfirmModalsProps> = ({
  deleteWorkType,
  deactivateWorkType,
  activateWorkType,
  isDeleting,
  isDeactivating,
  isActivating,
  onCloseDelete,
  onCloseDeactivate,
  onCloseActivate,
  onConfirmDelete,
  onConfirmDeactivate,
  onConfirmActivate,
}) => (
  <>
    {deleteWorkType && (
      <SettingsConfirmModal
        onClose={onCloseDelete}
        onConfirm={onConfirmDelete}
        isLoading={isDeleting}
        icon={<TrashSvg />}
        title={`Delete ‘${deleteWorkType.name}’ work type?`}
        description={"Do you want to permanently delete this work type?"}
        confirmText={"Delete"}
        variant={"danger"}
      />
    )}
    {deactivateWorkType && (
      <SettingsConfirmModal
        onClose={onCloseDeactivate}
        onConfirm={onConfirmDeactivate}
        isLoading={isDeactivating}
        icon={<WarningExclaimSvg sizeCx={"h-6 w-6"} />}
        title={`Deactivate ‘${deactivateWorkType.name}’ work type?`}
        description={
          "Are you sure you want to deactivate this work type? You can reactivate it at any time."
        }
        confirmText={"Deactivate"}
        variant={"warning"}
      />
    )}
    {activateWorkType && (
      <SettingsConfirmModal
        onClose={onCloseActivate}
        onConfirm={onConfirmActivate}
        isLoading={isActivating}
        icon={<WarningExclaimSvg sizeCx={"h-6 w-6"} />}
        title={`Activate ‘${activateWorkType.name}’ work type?`}
        description={
          "Are you sure you want to Activate this work type? You can deactivate it at any time."
        }
        confirmText={"Activate"}
        variant={"warning"}
      />
    )}
  </>
);
